import { AyurmaStrings } from "../../../i18n/ayurma";
import { SEVERITY_SCALE } from "../../../whiteLabel/whiteLabelTheme";

import classes from "./SeverityScaleLegend.module.css";

interface Props {
  severity: AyurmaStrings["severity"];
}

/**
 * The five-band score scale, printed with its numeric ranges.
 *
 * Not the shared Navbar/NavItem pair: those render a per-band count from the
 * payload, print no ranges, and carry a negative top margin with hardcoded
 * per-index flex weights.
 *
 * Band colours and boundaries come from SEVERITY_SCALE, so the printed ranges and
 * the bars on this page cannot drift apart.
 */
const SeverityScaleLegend = ({ severity }: Props): JSX.Element => (
  <div className={classes.legend}>
    <div className={classes.caption}>{severity.howToRead}</div>

    <div className={classes.bands}>
      {SEVERITY_SCALE.map((band) => (
        <div
          className={classes.band}
          key={band.key}
          style={{ backgroundColor: band.color }}
        >
          {severity.bands[band.key].label}
        </div>
      ))}
    </div>

    <div className={classes.ranges}>
      {SEVERITY_SCALE.map((band) => (
        <div className={classes.range} key={band.key}>
          {severity.bands[band.key].range}
        </div>
      ))}
    </div>
  </div>
);

export default SeverityScaleLegend;
